import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EndpointsComponent } from './components/endpoints/endpoints.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';

const routes: Routes = [
  { path: "usuarios", component: UsuariosComponent, data: { title: "usuarios" } },
  { path: "endpoints", component: EndpointsComponent, data: { title: "endpoints" } },
  { path: "properties", component: PropertiesComponent, data: { title: "properties" } },
  { path: "", redirectTo: "usuarios", pathMatch: "prefix" }, { path: "**", redirectTo: "usuarios", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigRoutingModule { }
